import { render } from "./fieldClassification.vue?vue&type=template&id=7c710cb4&scoped=true"
import script from "./fieldClassification.vue?vue&type=script&lang=js"
export * from "./fieldClassification.vue?vue&type=script&lang=js"

import "./fieldClassification.vue?vue&type=style&index=0&id=7c710cb4&lang=scss&scoped=true"

import exportComponent from "C:\\Jenkins\\workspace\\BT5\\rptweb\\feature_RPTWEB-3605_SERIALIZE-JAVASCRIPT_upgrade\\client\\databook\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c710cb4"]])

export default __exports__